import { HtmlId } from '../enum';
import { createRelatedLinks } from '@vfde-brix/ws10/related-links';
import { createComponentById, NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/ws10/core';

/**
 * Create Brix Related List component.
 * @param {HtmlId} id - ID of the element.
 * @returns {RelatedLinks | null} component or null if element with given id is not found
 */
export const mountRelatedLinks = (id: HtmlId) =>
    createComponentById(createRelatedLinks, id, NO_PATTERN_BUSINESS_LOGIC);
